export const CLASS_TOPBAR_STAT_ITEM = 'top-bar__stat-item';
export const CLASS_TOPBAR_STAT_ITEM_CONTAINER = CLASS_TOPBAR_STAT_ITEM + '-container';
